import React from 'react';
export function Navigation() {
  const links = ['World', 'South Asia', 'Politics', 'Business', 'Financial', 'Technology', 'Science', 'Lifestyle', 'Entertainment', 'Opinion'];
  return <nav className="sticky top-0 z-50 bg-paper border-b border-ink shadow-sm" data-id="element-45">
      <div className="max-w-7xl mx-auto px-4 overflow-x-auto" data-id="element-46">
        <ul className="flex items-center justify-between min-w-max md:min-w-0 py-3 md:py-4" data-id="element-47">
          {links.map(link => <li key={link} className="px-3 md:px-0" data-id="element-48">
              <a href={`#${link.toLowerCase().replace(' ', '-')}`} className="text-xs md:text-sm font-serif font-bold uppercase tracking-widest text-ink hover:text-accent hover:underline decoration-2 underline-offset-4 transition-all" data-id="element-49">
                {link}
              </a>
            </li>)}
        </ul>
      </div>
    </nav>;
}